module.exports = __webpack_public_path__ + "static/img/p5.618fab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/p5.png
// module id = 2kUr
// module chunks = 0